(function () {
    'use strict';

    // Track if already initialized to prevent duplicate listeners
    let isInitialized = false;

    function handleSubmit() {
        const submitButton = this.querySelector("blox-button");

        // Prevent double-submission
        if (submitButton && !submitButton.disabled) {
            submitButton.setAttribute('aria-label', 'Logging in, please wait');
            submitButton.textContent = '';
            submitButton.disabled = true;
            submitButton.loading = true;
        }
    }

    function initializeLoginForm() {
        if (isInitialized) {
            return;
        }

        const loginForm = document.querySelector("#login-form");

        if (!loginForm) {
            return;
        }

        loginForm.addEventListener('submit', handleSubmit);
        isInitialized = true;
    }

    // Handle both sync and async loading
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeLoginForm);
    } else {
        // DOM already loaded (async script case)
        initializeLoginForm();
    }
})();